<template>
    <div class="drug">
      <Search title="精准用药" :attent="num + '项需关注'" :total="'共计评价' + total + '种药物'" :child="child" backurl="/home">
        <div class="box">
          <van-tabs v-model="activeTab" @click="tabOnClick">
            <van-tab>
              <div slot="title">
                <span>{{ child === 1 ? '儿童时期需关注' : '需关注项目'}}</span>
              </div>

              <div v-show="gdb3">
                <div v-if="list.length === 0 && !loading"  class="noCarry">
                  <img src="../../assets/images/nothing3.png" alt="未携带">
                </div>

                <div v-else class="risk-cell" v-for="(item, index) in list" :key="index" @click.stop="$router.push('/drugInfo/' + item.id)">
                  <p class="title">{{item.name}}<span v-if="child === 1">（儿童时期）</span></p>
                  <p>关注方面：<span>{{ item.conclusion }}</span></p>
                  <div class="right-icon">
                    <i class="iconfont iconnext"></i>
                  </div>
                </div>
              </div>
              <div v-if="gdb2">
                <div v-if="list.length === 0 && !loading"  class="noCarry">
                  <img src="../../assets/images/nothing3.png" alt="未携带">
                </div>

                <div v-else class="risk-cell" v-for="(item, index) in list" :key="index" @click.stop="$router.push('/drugInfo/' + item.itemid)">
                  <p class="title">{{item.chname}}</p>
                  <p><span v-if="parseInt(item.tag)">关注方面:</span>{{item.conclusion || '无须关注'}}</p>
                  <div class="right-icon">
                    <i class="iconfont iconnext"></i>
                  </div>
                </div>
              </div>
            </van-tab>

            <van-tab v-if="child === 1" title="其他时期需关注" style="position: relative;">
              <div v-if="list.otherList === 0 && !loading"  class="noCarry">
                <img src="../../assets/images/nothing3.png" alt="未携带">
              </div>

              <div v-else class="risk-cell" v-for="(item, index) in otherList" :key="index" @click.stop="$router.push('/drugInfo/' + item.id)">
                <p class="title">{{item.name}}</p>
                <p>关注方面：<span>{{ item.conclusion }}</span></p>
                <div class="right-icon">
                  <i class="iconfont iconnext"></i>
                </div>
              </div>
            </van-tab>

            <van-tab>
              <div slot="title">
                <span>按系统浏览</span>
              </div>
              <Grids :gridsType="drugSystems" systems="drugType"></Grids>
            </van-tab>
          </van-tabs>
        </div>
      </Search>
    </div>
</template>

<script>
import Search from '@/components/Search'
import Grids from '@/components/Grids'
export default {
  name: 'index',
  data () {
    return {
      gdb3: false,
      gdb2: false,
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      num: '',
      total: '',
      activeTab: parseInt(this.$route.query.activeTab),
      list: [],
      otherList: [],
      drugSystems: [],
      follow_num: 0,
      sum: 0,
      grids: [],
      loading: true
    }
  },
  methods: {
    // 数量接口
    getQuantity () {
      this.util.get(this.api.drug_quantity, '', (success) => {
        this.num = success.num
        this.total = success.total
      })
    },
    tabOnClick (index) {
      this.$router.push({path: '/drug?num=' + this.num + '&total=' + this.total + '&activeTab=' + index})
      if (this.gdb3) {
        this.getDrugAttentionDrugs()
      }
    },
    getDrugAttentionDrugs () {
      this.util.get(this.api.drug_attention_drugs, '', (success) => {
        if (this.child === 1) {
          this.list = success.items.children
          this.otherList = success.items.adult
          if (this.activeTab === 0) {
            this.util.setLS('paginationData', success.items.children)
          } else if (this.activeTab === 1) {
            this.util.setLS('paginationData', success.items.adult)
          }
        } else {
          this.list = success.items
          this.util.setLS('paginationData', success.items)
        }
        this.loading = false
      })
    },
    getDrugSystems () {
      this.util.get(this.api.drug_systems, '', (success) => {
        this.drugSystems = [
          { icon: 'iconzhongliu', title: '抗肿瘤', num: success.items.抗肿瘤药物, id: '抗肿瘤药物' },
          { icon: 'iconxinnaoxieguan', title: '心血管', num: success.items.心血管药物, id: '心血管药物' },
          { icon: 'icon-fengshiguke', title: '风湿免疫', num: success.items.风湿免疫药物, id: '风湿免疫药物' },
          { icon: 'iconweiai', title: '消化系统', num: success.items.消化系统药物, id: '消化系统药物' },
          { icon: 'iconneifenmizhiliao', title: '内分泌', num: success.items.代谢与内分泌药物, id: '代谢与内分泌药物' },
          { icon: 'icon-huxidaojibing', title: '呼吸系统', num: success.items.呼吸系统药物, id: '呼吸系统药物' },
          { icon: 'iconminiao', title: '泌尿生殖', num: success.items.生殖与泌尿药物, id: '生殖与泌尿药物' },
          { icon: 'iconshenjingyuan', title: '神经类', num: success.items.神经类药物, id: '神经类药物' },
          { icon: 'iconjingshenke', title: '精神类', num: success.items.精神类药物, id: '精神类药物' },
          { icon: 'iconbingjun', title: '抗感染', num: success.items.抗感染药物, id: '抗感染药物' },
          { icon: 'iconshandian-', title: '抗炎镇痛', num: success.items.抗炎镇痛药物, id: '抗炎镇痛药物' },
          { icon: 'iconqita', title: '其他系统', num: success.items.其他系统药物, id: '其他系统药物' },
          { icon: 'iconclinicblood', title: '血液科药物', num: success.items.血液科药物, id: '血液科药物' },
          { icon: 'iconyanke', title: '眼科药物', num: success.items.眼科药物, id: '眼科药物' },
          { icon: 'icon-fashao', title: '解热镇痛药物', num: success.items.解热镇痛药物, id: '解热镇痛药物' },
          { icon: 'icon-mazuiqian', title: '麻醉类药物', num: success.items.麻醉类药物, id: '麻醉类药物' },
          { icon: 'icon-guominshi', title: '抗过敏药物', num: success.items.抗过敏药物, id: '抗过敏药物' }
        ]
        this.loading = false
      })
    },
    // gdb2
    getDrugIndex () {
      this.util.get1(this.api.drugIndex, '', (success) => {
        this.num = success.follow_num
        this.total = success.sum
        this.list = success.list
        this.loading = false
      })
    },
    getDrugSystems1 () {
      this.drugSystems = [
        { icon: 'iconzhongliu', title: '抗肿瘤', id: '抗肿瘤药物' },
        { icon: 'iconxinnaoxieguan', title: '心血管', id: '心血管药物' },
        { icon: 'icon-fengshiguke', title: '风湿免疫', id: '风湿免疫药物' },
        { icon: 'iconweiai', title: '消化系统', id: '消化系统药物' },
        { icon: 'iconneifenmizhiliao', title: '内分泌', id: '代谢与内分泌药物' },
        { icon: 'icon-huxidaojibing', title: '呼吸系统', id: '呼吸系统药物' },
        { icon: 'iconminiao', title: '泌尿生殖', id: '生殖与泌尿药物' },
        { icon: 'iconshenjingyuan', title: '神经类', id: '神经类药物' },
        { icon: 'iconjingshenke', title: '精神类', id: '精神类药物' },
        { icon: 'iconbingjun', title: '抗感染', id: '抗感染药物' },
        { icon: 'iconshandian-', title: '抗炎镇痛', id: '抗炎镇痛药物' },
        { icon: 'iconqita', title: '其他系统', id: '其他系统药物' }
      ]
      this.loading = false
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getQuantity()
      this.getDrugAttentionDrugs()
      this.getDrugSystems()
    } else {
      this.gdb2 = true
      this.getDrugIndex()
      this.getDrugSystems1()
    }
  },
  watch: {
    '$route' (to) {
      this.activeTab = parseInt(to.query.activeTab)
    }
  },
  components: {
    Search,
    Grids
  }
}
</script>

<style scoped>
 .drug {
   height: 100%;
   background-color: #fff;
 }
</style>



// WEBPACK FOOTER //
// src/views/drug/index.vue